import React, { useState } from "react";
import { useDispatch } from 'react-redux';
import * as Loadings from '../../../constants/loadings/user';
import * as R from 'ramda';
import { DownloadPrintFile } from '../../../actions/backoffice/user';

export const PrintModal = ({validatedletterSections, user, isLoading}) => {
	const dispatch = useDispatch();
	const userId = user.id;
	const [facultatives, setFacultatives] = useState([
		{ isChecked: false, name: "AIDE - CAF - Déclaration de situation pour prestations familiales et aides au logement", file: "GUIDE:AIDE - CAF - Declaration de situation pour prestations familiales et aides au logement.pdf" },
		{ isChecked: false, name: "AIDE - CAF - Déclaration revenus 2022", file: "GUIDE:AIDE - CAF - Declaration revenus 2022.pdf" },
		{ isChecked: false, name: "AIDE - CAF - Demande d'allocation Soutien Familial (ASF)", file: "GUIDE:AIDE - CAF - Demande dAllocation Soutien Familiale (ASF).pdf" },
		{ isChecked: false, name: "AIDE - CAF - Demande de Revenus Solidarité Active (RSA)", file: "GUIDE:AIDE - CAF - Demande de Revenus Solidarite Active (RSA).pdf" },
		{ isChecked: false, name: "AIDE - CPAM - Demande de Capital Décès", file: "GUIDE:AIDE - CPAM - Demande de Capital Deces.pdf" },
		{ isChecked: false, name: "AIDE - CR - Allocation décès mines", file: "GUIDE:AIDE - CR - Allocation deces mines.pdf" },
		{ isChecked: false, name: "AIDE - CR - Demande d'aide aux retraités en situation de rupture (ASIR)", file: "GUIDE:AIDE - CR - Demande daide aux retraites en situation de rupture (ASIR).pdf" },
		{ isChecked: false, name: "AIDE - CR - Demande d'aides à l'autonomie à domicile", file: "GUIDE:AIDE - CR - Demande daides a lautonomie a domicile.pdf" },
		{ isChecked: false, name: "AIDE - CR - Demande d'allocation de solidarité aux personnes âgées (ASPA)", file: "GUIDE:AIDE - CR - Demande dallocation de solidarite aux personnes agees (ASPA).pdf" },
		{ isChecked: false, name: "AIDE - CR - Demande d'allocation veuvage", file: "GUIDE:AIDE - CR - Demande dallocation veuvage.pdf" },
		{ isChecked: false, name: "AIDE - CR - Demande de secours exceptionnel - dépenses énergétiques", file: "GUIDE:AIDE - CR - Demande de secours exceptionnel - depenses energetiques.pdf" },
		{ isChecked: false, name: "AIDE - CR - Demande de secours exceptionnel - veuvage", file: "GUIDE:AIDE - CR - Demande de secours exceptionnel - veuvage.pdf" },
		{ isChecked: false, name: "AIDE - ENIM - Demande de secours frais obsèques", file: "GUIDE:AIDE - ENIM - Demande de secours frais obseques.pdf" },
		{ isChecked: false, name: "AIDE - ENIM - Règlement d'action sanitaire et sociale", file: "GUIDE:AIDE - ENIM - Reglement daction sanitaire et sociale.pdf" },
		{ isChecked: false, name: "Demandes acte de naissance pour PDR", file: "GUIDE:Demandes acte de naissance pour PDR.pdf" },
		{ isChecked: false, name: "DPR - AGIRC ARRCO", file: "GUIDE:DPR - AGIRC ARRCO.pdf" },
		{ isChecked: false, name: "DPR - CPR - SNCF", file: "GUIDE:DPR - CPR - SNCF.pdf" },
		{ isChecked: false, name: "DPR - Fonctionnaires - FSPOEIE", file: "GUIDE:DPR - Fonctionnaires - FSPOEIE.pdf" },
		{ isChecked: false, name: "DPR - Fonctionnaires - SRE CNRACL", file: "GUIDE:DPR - Fonctionnaires - SRE CNRACL.pdf" },
		{ isChecked: false, name: "DPR - Fonctionnaires, magistrats, militaires en activité", file: "GUIDE:DPR - Fonctionnaires, magistrats, militaires en activite.pdf" },
		{ isChecked: false, name: "DPR - Fonctionnaires, magistrats, militaires maj. enfants en activité", file: "GUIDE:DPR - Fonctionnaires, magistrats, militaires maj. enfants en activite.pdf" },
		{ isChecked: false, name: "DPR - Fonctionnaires, magistrats, militaires maj. enfants retraité", file: "GUIDE:DPR - Fonctionnaires, magistrats, militaires maj. enfants retraite.pdf" },
		{ isChecked: false, name: "DPR - Fonctionnaires, magistrats, militaires retraité", file: "GUIDE:DPR - Fonctionnaires, magistrats, militaires retraite.pdf" },
		{ isChecked: false, name: "DPR - IRCANTEC", file: "GUIDE:DPR - IRCANTEC.pdf" },
		{ isChecked: false, name: "DPR - Marins - ENIM", file: "GUIDE:DPR - Marins - ENIM.pdf" },
		{ isChecked: false, name: "DPR - Ouvriers de l'état - Retraite des mines", file: "GUIDE:DPR - Ouvriers de letat - Retraite des mines.pdf" },
		{ isChecked: false, name: "DPR - Salariés et indépendants - CARSAT MSA CAVIMAC CNAVPL", file: "GUIDE:DPR - Salaries et independants - CARSAT MSA CAVIMC CNAPVL.pdf" },
		{ isChecked: false, name: "NOTAIRE - Dossier Succession", file: "GUIDE:NOTAIRE - Dossier Succession.pdf" },
		{ isChecked: false, name: "SANS NOTAIRE - Attestation porte-fort", file: "GUIDE:SANS NOTAIRE - Attestation porte-fort.pdf" },
		{ isChecked: false, name: "SANS NOTAIRE - Attestation sur l'honneur des héritiers", file: "GUIDE:SANS NOTAIRE - Attestation sur lhonneur des heritiers.pdf" },
		{ isChecked: false, name: "SANS NOTAIRE - FICOBA", file: "GUIDE:SANS NOTAIRE - FICOBA.pdf" },
		{ isChecked: false, name: "SANS NOTAIRE - FICOVIE", file: "GUIDE:SANS NOTAIRE - FICOVIE.pdf" },
		{ isChecked: false, name: "SANS NOTAIRE - Demande de certificat d'absence de dispositions de dernières volontés (FCDDV)", file: "GUIDE:SANS NOTAIRE - Demande de certificat absence de dispositions de dernieres volontes - FCDDV.pdf" },
		{ isChecked: false, name: "Particulier employeur", file: "GUIDE:Particulier employeur.pdf" },
	]);
	const sortedFacultatives = R.sortBy(R.prop('name'), facultatives);
	const sortedValidatedletterSections = R.sortBy(R.prop('title'), validatedletterSections);

	return (
		<div className="modal fade px-0" id="printModal" aria-labelledby="printModalLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-sm">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-success rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Prints</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-success text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="printModalLabel">
									Impressions
								</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default py-0">
						<p className="h5 lh-copy">Guides disponibles:</p>
						<div className="flex-column align-items-start">
							{sortedFacultatives.map((letter, index) => (
								<div className="form-check form-check-inline custom-control custom-checkbox" key={index}>
									<input
										className="custom-control-input"
										type="checkbox"
										name="inlineRadioOptions1"
										id={"inlineRadio1-" + index}
										checked={letter.isChecked}
										onChange={(event) => {
											setFacultatives(facultatives.map((item, idx) => (item.name === letter.name ? { ...item, isChecked: event.target.checked } : item)));
										}}
									/>
									<label className="custom-control-label h5 font-weight-bold ls-n1" htmlFor={"inlineRadio1-" + index}>
										{letter.name}
									</label>
								</div>
							))}
						</div>
						<hr />
						<p className="h5 lh-copy">Lettres validées (à inclure dans le fichier d'impression):</p>
						{
							validatedletterSections.length === 0 ?
								<p className="h5 lh-copy o-50">Aucune lettre validée</p>
							:
								<p className="h5 lh-copy o-70">
									{
										
										sortedValidatedletterSections.map(l => l.title).join(", ")
									}
								</p>
						}
						
					</div>
					<div className="modal-footer justify-content-center">
						<button type="button" className="btn btn-faded" data-dismiss="modal">
							Annuler
						</button>
						{
							validatedletterSections.length === 0 ?
								<button type="button" className="btn btn-info px-md-gutter px-4" disabled={true}>Générer</button>
							:
								<button type="button" className={"btn btn-info px-md-gutter px-4 loading-btn" + (isLoading.includes(Loadings.GENERATING_PRINT) ? ' show' : '')} disabled={isLoading.includes(Loadings.GENERATING_PRINT) || validatedletterSections.length === 0} onClick={(e) => {e.preventDefault(); dispatch(DownloadPrintFile(userId, facultatives.filter(f => f.isChecked)))}}>
									Générer
									<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
								</button>
						}
					</div>
				</div>
			</div>
		</div>
	);
};
